import WithdrawingButton from '../../../components/withdrawing_button.js';
import '../style/withdrawing_page.css'
import AppBar from '../../../components/app_bar.js'
import BottomNavBar from "../../../components/bottom_nav_bar.js";
import Background from "../../../components/background.js";
import { withdraw } from '../../../api/api.js';
import { useNotification } from "../../../components/NotificationProvider.js";
import t from "../../../translate";

function WithdrawPage() {
  const { addNotification } = useNotification();

  function getArray() {
    let count = +localStorage.getItem('countWithdraw') || 0

    const array = []
    const basePrice = 200
    const step = 200

    for (let i = 0; i <= 2; i++) {
      let amount = basePrice + (i + count) * step
      array.push({ amount, label: `${amount} ⭐️` },
      )
    }
    if (count === 0) {
      array[0].amount = 15
      array[0].label = `15 ⭐️`

      array[1].amount = 200
      array[1].label = `200 ⭐️`

      array[0].amount = 400
      array[0].label = `400 ⭐️`
    }

    return array
  }

  const buttons = getArray().map((item, index) => (
    <WithdrawingButton key={index} value={item.amount} onTap={() => withdrawRequest(item.amount)} />
  ));

  async function withdrawRequest(amount) {
    try {
      const res = await withdraw(localStorage.getItem('userId'), amount)

      localStorage.setItem('tapCounter', res.data.tapCounter.toFixed(3))

      addNotification('success', 'Заявка принята, в работе.')
    } catch (error) {
      if (error.response && error.response.data) {
        addNotification('error', error.response.data.message)
        return;
      }
      return
    }
  }

  return <>
    <AppBar />
    <BottomNavBar />
    <Background />
    <div className="withdrawing-page default-page-setting">
      <img className="spring-on-background" src="/assets/icons/ic_spring.svg" alt="ic_spring" />
      <div className="stars-counter top-margin">
        <h5 className="withdrawing-page-title">{t(localStorage.getItem('lang'), 'yourBalance')}</h5>
        <h1>{localStorage.getItem('tapCounter') || 0}</h1>
        <h5>Stars</h5>
      </div>
      <div className="middle-content">
        <h3>{t(localStorage.getItem('lang'), 'howMuchWithdraw')}</h3>
        <div className="button-row">
          {buttons}
        </div>
      </div>
      <div className="bottom-content">
        {/* <LinkButton value={'Как заработать друзей'} onTap={() => window.open(process.env.REACT_APP_HOW_GET_FRIENDS_URL, '_blank')} />
        <LinkButton value={'Как добавить ссылку'} onTap={() => window.open(process.env.REACT_APP_HOW_SET_LINK, '_blank')} /> */}
      </div>
    </div>;
  </>
}

export default WithdrawPage;